
	import {
		message
	} from 'ant-design-vue';
	import {
		defineComponent,
		onMounted,
		ref,
		reactive
	} from 'vue';
	import cityData from '@/assets/data/city.json';
	import taskreviewer from '@/service/taskreviewer'
	import inforeview from '@/service/inforeview'
	export default defineComponent({
		components: {},
		props: {
			
		},
		setup(props, context) {
			// 声明
			let visible = ref(false);
			let formState = reactive({
				id: '',
				taskId: '',
				taskName: '',
				mode: '0',
				schoolCode: sessionStorage.getItem('schoolCode'),
				userType: '',
				loginName: '',
				userName: '',
				studyPhase: '',
				subject: '',
				tel: '',
				positionTitle: '',
				unit: '',
				reviewerType: '',
				district: [],
				peopleDateLists: [],
				peopleDateAllLists: []
			});
			let selectUsers = ref('');

			// 页面渲染时加载
			onMounted(() => {

			})
			// 打开页面
			const open = (e, taskId, taskName) => {
				setForm();
				visible.value = true;
				queryUserLists(e);
				selectUsers.value = '';
				formState.taskId = taskId;
				formState.taskName = taskName;
				formState.reviewerType = e.reviewerType;
				formState.id = e.id;
				formState.enrollId = e.enrollId;
			}
			// 获取用户管理人员
			const queryUserLists = (e) => {
				let userLists = [];
				taskreviewer.queryTaskreviewer(e.schoolCode, e.taskId, "", "", "", e.reviewerType).then(({
					data
				}) => {
					if (data.code !== 0) return;
					if (data.data) {
						data.data.map(item => {
							cityData[0].children[0].children.map(item2 => {
								if (item2.value == item.district) {
									item.districtMap = "上海市/市辖区/" + item2.label
								}
							})
							if(item.studyPhase==undefined || item.studyPhase==null || item.studyPhase==""){
								item.studyPhase ="-"
							}
							if(item.subject==undefined || item.subject==null || item.subject==""){
								item.subject ="-"
							}
							if(item.districtMap==undefined || item.districtMap==null || item.districtMap==""){
								item.districtMap ="-"
							}

							userLists.push({
								label: item.userName + "," + item.studyPhase + ","+ item.subject +","+ item.districtMap,
								value: item.id,
							})
						})
					}
					formState.peopleDateAllLists = data.data;
					formState.peopleDateLists = userLists;
				})
			}
			// 搜索用户管理的人员
			const filterOptions = (input, option) => {
				return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
			};
			// 提交表单
			const handleOk = () => {
				let dataJson;
				if (selectUsers.value == '') {
					message.warning('请选择用户管理中的人员');
					return;
				}
				
				let selectUserInfo = formState.peopleDateAllLists[formState.peopleDateAllLists.findIndex(
					item => item.id == selectUsers.value)];
				dataJson = {
					schoolCode: formState.schoolCode,
					id: formState.id,
					taskId: formState.taskId,
					taskName: formState.taskName,
					enrollId:formState.enrollId,
					userId: selectUserInfo.userId,
					userName:selectUserInfo.userName,
					loginName: selectUserInfo.loginName,
					userType: selectUserInfo.userType,
					studyPhase: selectUserInfo.studyPhase,
					subject: selectUserInfo.subject,
					tel: selectUserInfo.tel,
					positionTitle: selectUserInfo.positionTitle,
					unit: selectUserInfo.unit,
					district: selectUserInfo.district,
					reviewerType: formState.reviewerType,
				};
				//更改个人信息
				inforeview.changeReviewer(dataJson).then(({
					data
				}) => {
					if (data.code == '0') {
						message.success(data.msg);
						visible.value = false;
						setForm();
						context.emit('queryTable', 'ok');
					} else {
						message.error(data.msg);
					}
				})
			}
			//  清空表单
			const setForm = () => {
				formState.id = '';
				formState.taskName = '';
				formState.taskId = '';
				formState.loginName = '';
				formState.studyPhase = [];
				formState.subject = [];
				formState.tel = '';
				formState.positionTitle = '';
				formState.unit = '';
				formState.reviewerType = '';
				formState.userName = '';
				formState.district = '';
				formState.userType = '';
			}

			return {
				open,
				visible,
				formState,
				handleOk,
				selectUsers,
				setForm,
				queryUserLists,
				filterOptions,
				cityData
			};
		},

	});
